import { AspectRatio, Box, Text, VStack } from '@chakra-ui/react';
import CreatorIdentity from '@/modules/content/loop/parts/CreatorIdentity';
import LoopStage from '@/modules/content/loop/parts/LoopStage';
import LoopTitle from '@/modules/content/loop/parts/LoopTitle';
import PublishedMetaRow from '@/modules/content/loop/parts/PublishedMetaRow';
import VideoFrame from '@/modules/content/loop/parts/VideoFrame';
import { getLandscapeWidth } from '@/modules/content/loop/model/loopLayout';
import { dimUntilHoverGroup } from '@/modules/content/loop/model/loopChrome';
import { TLoopReelProps } from '@/modules/content/loop/model/types';

// Reel · landscape — video centred, attribution and copy below it. Mostly regular
// (non-Short) YouTube. No left zone: the copy lives under the video, so the media is
// centred against empty space on one side and the rail on the other.
const LandscapeReel = ({
  content,
  isActive,
  onNotInterested,
  onReport,
  onRatioDetected,
  onPlayStateChange,
  onProgress,
  ratio,
  rail,
  nav,
}: TLoopReelProps) => (
  <LoopStage
    center={
      <VStack align="stretch" gap="16px" width={{ base: '100%', md: getLandscapeWidth(ratio) }}>
        {/* Landscape stays width-driven — it has copy below it, so filling the viewport
            height (as the portrait reel does) would push the attribution off-screen. */}
        <Box borderRadius="16px" overflow="hidden" backgroundColor="background.cloudGray">
          <AspectRatio ratio={ratio} width="100%">
            <Box>
              <VideoFrame
                content={content}
                isActive={isActive}
                onRatioDetected={onRatioDetected}
                onPlayStateChange={onPlayStateChange}
                onProgress={onProgress}
              />
            </Box>
          </AspectRatio>
        </Box>

        {/* The attribution block runs to half the video's width, not its full width — a
            full-width measure would stretch the title and description into very long
            lines under a wide video. The half-width also pulls the view count, the
            overflow menu and the domain tiles in to that midpoint, since each of those
            rows aligns to its own right edge. */}
        <VStack align="stretch" gap="10px" width={{ base: '100%', md: '50%' }} {...dimUntilHoverGroup}>
          <CreatorIdentity content={content} onNotInterested={onNotInterested} onReport={onReport} />
          <LoopTitle>{content.title || 'Untitled'}</LoopTitle>
          {content.description && (
            <Text fontSize="13px" color="text.mediumBlue" lineHeight="19px" noOfLines={3}>
              {content.description}
            </Text>
          )}
          <PublishedMetaRow content={content} />
        </VStack>
      </VStack>
    }
    right={
      <>
        {rail}
        {nav}
      </>
    }
  />
);

export default LandscapeReel;
